export default function (initialDataInteractor, questionnaireId) {
  let foundQuestionnaire = {};

  initialDataInteractor.data.questionnaires.forEach(function (questionnaire) {
    if (questionnaire['id'] == questionnaireId) {
      foundQuestionnaire = questionnaire;
    }
  });


  return foundQuestionnaire;
}